module.exports = __webpack_public_path__ + "static/media/34-10.115644cf.mp3";